'use strict';

var FlightAnalysisConfig = function FlightAnalysisConfig($stateProvider) {
  $stateProvider.state('app.flight-analysis', {
    url: '/workflow/flight-analysis',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER,DYNAMIC_AVAILABILITY'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-flight-analysis-panel></rm-flight-analysis-panel>'
      }
    }
  });
};
FlightAnalysisConfig.$inject = ['$stateProvider'];
module.exports = FlightAnalysisConfig;